module.exports = __webpack_public_path__ + "static/aaron-doodle-c94a73bc92359b5d49db8d1849149e33.svg";